import { matchPath, useLocation } from 'react-router-dom';

export enum RoutePaths {
  Deeplink = '/deeplink/:code',
  DeviceAccessIssue = '/in-call/device-access-issue',
  DeviceCheck = '/device-check', // Technically from a different workflow
  DeviceCheckSpeaker = '/device-check/speaker', // Technically from a different workflow
  DeviceCheckMicrophone = '/device-check/microphone', // Technically from a different workflow
  DeviceCheckVideo = '/device-check/video', // Technically from a different workflow
  DeviceCheckComplete = '/device-check/complete', // Technically from a different workflow
  DeviceCheckFAQ = '/device-check/faq', // Technically from a different workflow
  InvalidAppointment = '/invalid-appointment',
  MeetingInit = '/in-call',
  Meeting = '/in-call/meeting',
  MeetingSummary = '/in-call/meeting-summary',
  ReadinessCheck = '/in-call/readiness-check',
  WaitingRoom = '/in-call/waiting-room',
  Welcome = '/join/:token',
}

// defines the mapping of route paths to route names.  route names are used as
// page names in amplitude events
const routePathNameMap: { [index: string]: string } = {
  [RoutePaths.Deeplink]: 'Deeplink',
  [RoutePaths.DeviceAccessIssue]: 'DeviceAccessIssue',
  [RoutePaths.DeviceCheck]: 'DeviceCheckLanding', // Technically from a different workflow
  [RoutePaths.DeviceCheckSpeaker]: 'DeviceCheckSpeakerTest', // Technically from a different workflow
  [RoutePaths.DeviceCheckMicrophone]: 'DeviceCheckMicTest', // Technically from a different workflow
  [RoutePaths.DeviceCheckVideo]: 'DeviceCheckCameraTest', // Technically from a different workflow
  [RoutePaths.DeviceCheckComplete]: 'DeviceCheckComplete', // Technically from a different workflow
  [RoutePaths.DeviceCheckFAQ]: 'DeviceCheckFAQ', // Technically from a different workflow
  [RoutePaths.InvalidAppointment]: 'InvalidAppointment',
  // Note: MeetingInit and Meeting routes intentionally share the same InCall route name
  [RoutePaths.MeetingInit]: 'InCall',
  [RoutePaths.Meeting]: 'InCall',
  [RoutePaths.MeetingSummary]: 'ThankYou',
  [RoutePaths.ReadinessCheck]: 'ReadinessChecks',
  [RoutePaths.WaitingRoom]: 'WaitingRoom',
  [RoutePaths.Welcome]: 'Welcome',
};

export const useRouteNameMapper = () => {
  const { pathname } = useLocation();
  const matched = Object.entries(routePathNameMap).find(([routePath /* name */]) => {
    return !!matchPath(routePath, pathname);
  });

  return (matched && matched[1]) || 'UnknownRoute';
};
